// extracted by mini-css-extract-plugin
module.exports = {"description":"Opened_description__20LtI","edit-btn":"Opened_edit-btn__1Z1ox","form-item-wrapper":"Opened_form-item-wrapper__h0s6z"};